module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAYAAADeiIy1AAABTklEQVRIS72VvytFcRjGP88isZCBwSiLyWIzyGggDMjgb5DEblPsFpsMitGokJWSkvJjUn6WwSDXo1f3Gm5xvuc61zue83yfz/u837dzZHscWANaqU/dApOy/QC0AZfAS8GsJqAbOAmQgTNJPQVDvuxs7wOdFdCepIE6gaaAjrqDKs0ng2xLUoy5pkoC2W4GLoDY0KM8QNtd0VkqqAV4LkfZBaYlPaZEs31VK6jivwCsSnr7DVgE6BUYkxQJf6y/gsJ8SNJH1vhqBd0Dg8Bp6kLYbsxzRyEeBbay7uSnhElblzWelPf/DjqQ1J/SWV6N7VicUiQqAe/AJvCU1yhD3w5MADcBWgdmCgZU2y0FqAGIscVnJqv6gPmyaA64zjoA3AGHShB+S2wPAzvlB72SjlPPJ4NsR+oRYLZsvghsSzpPgeUBrQDVf+FlSRspoE+NkMUOnUtP5QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/street/index-icon-czjc.png
// module id = fFPF
// module chunks = 208